import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-design-terms',
  templateUrl: './confirm-design-terms.component.html',
  styleUrls: ['./confirm-design-terms.component.scss']
})
export class ConfirmDesignTermsComponent implements OnInit {
  constructor(
    public matDialog : MatDialog,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }
  
  terms: boolean = false;

  closeModal() {
    this.matDialog.closeAll()
  }

  ngOnInit(): void {
  }

}
